export class ScheduleComponent {
	private idSchedules: string;
	private deliveringsId: string;
	private idExclusion: string;
	private beginTime: string;
	private endTime: string;
	private maxOccupation: string;
	private actualOccupation: string;
	private days: string;
	private date: string;

	constructor(idSchedules?: string, deliveringsId?: string, idExclusion?: string, beginTime?: string, endTime?: string, maxOccupation?: string, days?: string, date?: string) {
		this.idSchedules = idSchedules;
		this.deliveringsId = deliveringsId;
		this.idExclusion = idExclusion;
		this.beginTime = beginTime;
		this.endTime = endTime;
		this.maxOccupation = maxOccupation;
		this.days = days;
		this.date = date;
	}

	public static fromJSON(scheduleJSON) {
		let ret = null;

		if (scheduleJSON == null) {
			return ret;
		}

		ret = new ScheduleComponent(scheduleJSON.idSchedules,
			scheduleJSON.deliveringsId,
			scheduleJSON.idExclusion,
			scheduleJSON.beginTime,
			scheduleJSON.endTime,
			scheduleJSON.maxOccupation,
			scheduleJSON.day,
			scheduleJSON.date);

		if (scheduleJSON.actualOccupation != undefined) {
			ret.setActualOccupation(scheduleJSON.actualOccupation);
		}

		return ret;
	}

	public setIdSchedules(idSchedules: string) { this.idSchedules = idSchedules; }
	public getIdSchedules() { return this.idSchedules; }

	//Getters y setters provisionales puesto que no sabemos si se sigue usando en otro sitio el getId
	public setId(idSchedules: string) { this.idSchedules = idSchedules; }
	public getId() { return this.idSchedules; }

	public setDeliveringsId(deliveringsId: string) { this.deliveringsId = deliveringsId; }
	public getDeliveringsId() { return this.deliveringsId; }

	public setIdExclusion(idExclusion: string) { this.idExclusion = idExclusion; }
	public getIdExclusion() { return this.idExclusion; }

	public setBeginTime(beginTime: string) { this.beginTime = beginTime; }
	public getBeginTime() { return this.beginTime; }

	public setEndTime(endTime: string) { this.endTime = endTime; }
	public getEndTime() { return this.endTime; }

	public setMaxOccupation(maxOccupation: string) { this.maxOccupation = maxOccupation; }
	public getMaxOccupation() { return this.maxOccupation; }

	public setActualOccupation(actualOccupation: string) { this.actualOccupation = actualOccupation; }
	public getActualOccupation() { return this.actualOccupation; }

	public setDays(days: string) { this.days = days; }
	public getDays() { return this.days; }

	public setDate(date: string) { this.date = date; }
	public getDate() { return this.date; }

	public getDescription() { return this.beginTime + ' - ' + this.endTime; }

	public searchForId(idSearched: string) {
		if (idSearched == this.idSchedules) {
			return true;
		} else {
			return false;
		}
	}
}



// WEBPACK FOOTER //
// ../Alsa-MA-Angular-administrar-tarjetas/src/app/DTOs/Schedule.component.ts